module.exports = __webpack_public_path__ + "img/interact_feature_6.4d901a8a.png";